import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getApi } from "../../../../api/api";
import { selectClusterList } from "../../../../store/slices/clusterListSlice";
import {
  CLUSTERS_ROUTE,
  CATEGORIES_ROUTE,
  ITEMS_ROUTE,
  PROMOS_ROUTE,
} from "../../../../common/utils/constants";
import { useCityId } from "../../../../common/hooks/useCityId";

export const useSectionsNav = () => {
  const clusters = useSelector(selectClusterList);
  const cityId = useCityId()

  const [itemsCount, setItemsCount] = useState(0);
  const [categoriesCount, setCategoriesCount] = useState(0);
  const [promosCount, setPromosCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    getApi()
      .getItems({ limit: 1, cityId })
      .then((res) => {
        if (!cancelled) setItemsCount(res.total);
      })
      .catch(() => {
        if (!cancelled) setItemsCount(0);
      });

    getApi()
      .getCategories({ cityId })
      .then((res) => {
        if (!cancelled) setCategoriesCount(res.total);
      })
      .catch(() => {
        if (!cancelled) setCategoriesCount(0);
      });

    getApi()
      .getPromos({ limit: 1, cityId })
      .then((res) => {
        if (!cancelled) setPromosCount(res.total);
      })
      .catch(() => {
        if (!cancelled) setPromosCount(0);
      });

    return () => {
      cancelled = true;
    };
  }, [cityId]);

  const items = [
    { path: ITEMS_ROUTE, label: "Товары", count: itemsCount },
    { path: CATEGORIES_ROUTE, label: "Категории", count: categoriesCount },
    { path: CLUSTERS_ROUTE, label: "Компании", count: clusters.length },
    { path: PROMOS_ROUTE, label: "Акции", count: promosCount },
  ];

  return { items };
};
